"use client";

import Image from 'next/image'
import styles from './index.module.scss';
import logo from '@/app/images/logo.png';
import Link from 'next/link'
import AppStoreButtons from '@/app/_components/Shared/AppStoreButtons'

const quickLinks = [
  { text: 'Home', link: '/' },
  { text: 'Services', link: '/services/bank-account-opening' },
  { text: 'Business Setup', link: '/business-setup' },
  { text: 'Banking', link: '/banking' },
  { text: 'About', link: '/about-us' },
  { text: 'Blog', link: '/blog' },
];

const proServices = [
  { text: 'Request PRO Services', link: '/pro-services-request' },
  { text: 'Bank Account Opening', link: '/services/bank-account-opening' },
  { text: 'Accounting', link: '/services/accounting' },
  { text: 'Legal Services', link: '/services/legal' },
  { text: 'Administrative Services', link: '/services/administrative-services' },
  { text: 'Translation', link: '/services/translation' },
];

export default function Footer() {
    return (
        <footer id="contact" className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    {/* Company Info */}
                    <div className={styles.column}>
                        <div className={styles.logoWrapper}>
                            <Image className={styles.logo} src={logo} alt="Ninjaz Logo"/>
                        </div>
                        <p className={styles.description}>
                            Your trusted partner for PRO services in Dubai. Empowering your business with digital solutions to cashless and digitalization.
                        </p>
                        <div className={styles.appButtons}>
                            <h4 className={styles.appTitle}>Download Our App</h4>
                            <AppStoreButtons variant="footer" />
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className={styles.column}>
                        <h4 className={styles.columnTitle}>Quick Links</h4>
                        <ul className={styles.list}>
                            {quickLinks.map((item, index) => (
                                <li key={index}>
                                    <Link href={item.link}>{item.text}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* PRO Services */}
                    <div className={styles.column}>
                        <h4 className={styles.columnTitle}>PRO Services</h4>
                        <ul className={styles.list}>
                            {proServices.map((item, index) => (
                                <li key={index}>
                                    <Link href={item.link}>{item.text}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Get in Touch */}
                    <div className={styles.column}>
                        <h4 className={styles.columnTitle}>Get in Touch</h4>
                        <ul className={styles.contactList}>
                            <li className={styles.contactItem}>
                                <svg className={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                <a href="mailto:info@ninjaz.ae">info@ninjaz.ae</a>
                            </li>
                            <li className={styles.contactItem}>
                                <svg className={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                                <a href="tel:+971585987822">+971 58 598 7822</a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className={styles.bottomBar}>
                    <p className={styles.copyright}>
                        © 2025 Ninjaz. All rights reserved.
                    </p>
                    <div className={styles.legalLinks}>
                        <Link href="/privacy">Privacy Policy</Link>
                        <Link href="/terms">Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
